import { render, staticRenderFns } from "./BetOutcomeModal.vue?vue&type=template&id=533c13cf"
import script from "./BetOutcomeModal.vue?vue&type=script&lang=ts"
export * from "./BetOutcomeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports